import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import SVGInline from 'react-svg-inline';

import PropTypes from 'prop-types';

// eslint-disable-next-line no-unused-vars
import { openGeneralMessageModal, sendContactCall } from '../../../Actions/main';
import {contactErrorMsg, invalidEmailErrorMsg} from "../../../Models/errors";


// svgs
import noteBlueMugicsSVG from '../../inlineSVGs/noteBlueMugicsSVG';
import pianoMugicsSVG from '../../inlineSVGs/pianoMugicsSVG';
import closeCrossSVG from '../../inlineSVGs/closeCrossSVG';
import lightningSvg from '../../inlineSVGs/lightningSVG';
// import shadowMugicsSVG from '../../inlineSVGs/shadowMugicsSVG';

// styles
import '../stylesModal.css';
import './styles.css';

import { InputSmall, InputTextArea } from '../../Elements/Inputs';
import { ButtonSimple } from '../../Elements/Buttons';
import {isEmailValid} from "../../../utils";

class Contact extends Component {
    constructor (props) {
        super(props);
        this.state = {
            email: '',
            message: ''
        }
    }

    onEmailChange(input) {
        this.setState({ email: input });
    }

    onMessageChange(input) {
        this.setState({ message: input });
    }

    onSubmit() {
        const contact = {
            email: this.state.email,
            message: this.state.message
        };

        let message;

        if (contact.email && !isEmailValid(this.state.email)) message = invalidEmailErrorMsg();

        if (!contact.email || !contact.message) message = contactErrorMsg();

        if (message) return this.props.openGeneralMessageModal(message.header, message.body);

        this.props.sendContactCall(contact);

        setTimeout(() => {
            this.props.closeModal();
        }, 1000);
    }

    render() {
        return (
            <div>
                <Modal
                    isOpen={this.props.isModalOpen}
                    contentLabel="Content"
                    className="modal-wrapper contact-wrapper rtl"
                    style={{overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0)',
                            zIndex: 100
                        }}}
                >
                    <div onClick={this.props.closeModal} >
                        <SVGInline className="close-button" svg={closeCrossSVG} component="i"/>
                    </div>
                    <div className="content">
                        <div className="title">
                            <hr/>
                            <p>שגרו הודעה</p>
                            <SVGInline svg={lightningSvg} width="35px" fill="#6dc6b0"/>
                            <hr/>
                        </div>
                        <div className="input-wrapper">
                            <SVGInline svg={pianoMugicsSVG} component="i" width="100px" />
                        </div>
                        <InputSmall
                            onChange={(event) => this.onEmailChange(event.target.value)}
                            placeholder="מייל"
                            type="email"
                        />
                        <InputTextArea
                            onChange={(event) => this.onMessageChange(event.target.value)}
                            placeholder="בואו נדבר:"
                            rows={12}
                        />
                        <div className="button-wrapper-outer">
                            <SVGInline svg={noteBlueMugicsSVG} width="100px" component="i" />
                            <ButtonSimple
                                onPress={() => this.onSubmit()}
                                label="שליחה"
                            />
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

Contact.propTypes = {
    isModalOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    sendContactCall: PropTypes.func,
    openGeneralMessageModal: PropTypes.func
};

export default connect(null, { sendContactCall, openGeneralMessageModal })(Contact);



// WEBPACK FOOTER //
// ./src/Components/Modals/Contact/Contact.js